import { useEffect, useState } from "react";
import { AuthorizedLayout } from "../../../../components/AuthorizedLayout";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../../utils/api";
import iconBack from "../../../../assets/Tipode material.png";
import checkIcon from "../../../../assets/Frame 20 (8).png";

import "./DetailsPodLive.css";
import LoadingIcon from "../../../../components/LoadingIcon";
import iconHeart from "../../../../assets/Vector (23).png";
import YoutubeEmbed from "../../../../components/YoutubeEmbed/YoutubeEmbed";
import TeacherCard from "../../../../components/TeacherCard/TeacherCard";

export const DetailsPodLive = () => {
  const { id, type } = useParams();
  const navigate = useNavigate();
  const [listCourse, setCourse] = useState([]);
  const [loading, setLoading] = useState(false);

  const getCourses = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/talents/media/${id}/details`);
      setCourse(
        {
          id: data?.data?.id,
          ...data?.data?.attributes,
        } || []
      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCourses();
  }, [id]);

  const checkView = async () => {
    try {
      await api.post(`/talents/media/${listCourse?.id}/mark_watched`);
      setCourse({ ...listCourse, watched: true });
    } catch (error) {
      console.log(error);
    }
  };

  const unmarkView = async () => {
    try {
      await api.post(`/talents/media/${listCourse?.id}/unmark_watched`);
      setCourse({ ...listCourse, watched: false });
    } catch (error) {
      console.log(error);
    }
  };

  const handleNavigate = async () => {
    navigate(-1);
  };

  const handleVideoEnd = async () => {
    if (!listCourse?.watched) {
      await checkView();
      setCourse({ ...listCourse, watched: true });
    }
  };

  const nextLeason = async () => {
    navigate(
      `/${type === "podcast" ? "podcast" : "live"}/${
        listCourse?.relatedMedia?.title
      }/${listCourse?.relatedMedia?.id}`
    );
  };

  const getYouTubeVideoId = (url) => {
    try {
      const urlObj = new URL(url);
      if (urlObj.hostname === "youtu.be") {
        return urlObj.pathname.substring(1);
      }
      return urlObj.searchParams.get("v");
    } catch (error) {
      return null;
    }
  };

  const videoId = getYouTubeVideoId(listCourse?.url);

  const thumbnailUrl = (url) => {
    const videoId = getYouTubeVideoId(url);
    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  };

  return (
    <AuthorizedLayout>
      <>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "70vh",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                // height: "150px",
                width: "250px",
                marginTop: "50px",
              }}
            >
              <LoadingIcon />
            </div>
          </div>
        ) : (
          <div className="containerDetailsPodLive">
            <div className="containerDetails">
              <div className="containerHeader" onClick={handleNavigate}>
                <img src={iconBack} alt="" />
                {/* <span>{truncateText(listCourse?.title, 30)}</span> */}
                <span>Voltar</span>
              </div>
              <div>
                <YoutubeEmbed videoId={videoId} onVideoEnd={handleVideoEnd} />
              </div>
              <div className="containerTeacher">
                <div className="headers">
                  <div className="containerText2">
                    <div>{listCourse?.title}</div>
                    {Array.isArray(listCourse?.instructors) && listCourse.instructors.length > 0 && (
                      <div className="text2">
                        {listCourse.instructors.length === 1 ? "Participante: " : "Participantes: "}
                        <span>{listCourse.instructors.map((item) => item.name).join(", ") + "."}</span>
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className="description"
                  dangerouslySetInnerHTML={{ __html: listCourse?.description }}
                />
              </div>

              <button
                className={`checkVideo ${listCourse?.watched && "checked"}`}
                style={{
                  flex: !listCourse.nextLesson && "none"
                }}
                onClick={async () => {
                  if (listCourse?.watched) {
                    await unmarkView();
                  } else {
                    await checkView();
                  }
                }}
              >
                <div className="cicle"></div>
                {listCourse.watched && (
                  <img src={checkIcon} alt="" className="imgCheck" />
                )}
                {type === "podcast" ? "Podcast assistido" : "Live assistida"}
              </button>

              {listCourse?.instructors?.map((i, idx) => (
                <TeacherCard key={idx} photoUrl={i?.photoUrl} name={i?.name} description={i?.description} />
              ))}

              {listCourse.relatedMedia &&
                listCourse?.relatedMedia?.length > 0 && (
                  <>
                    <div className="textSugestao">Veja também:</div>
                    <div className={`card`} onClick={nextLeason}>
                      <div className={`thumbnail`}>
                        <img src={checkIcon} alt="" className="iconPLay" />
                        {thumbnailUrl && (
                          <img src={thumbnailUrl} alt="" className="thumb" />
                        )}
                      </div>
                      <div className="containerText">
                        <div className="title">
                          {listCourse?.nextLesson?.title}
                        </div>
                      </div>
                    </div>
                  </>
                )}
            </div>
          </div>
        )}
      </>

      <div
        className={
          listCourse?.length <= 1 ? "footerMobileFixed" : "footerMobile"
        }
      >
        Desenvolvido com
        <img src={iconHeart} alt="" />
        <strong>© eComLovers®</strong>
      </div>
    </AuthorizedLayout>
  );
};
